'use strict';
import {reduxList} from '../redux/autoList';
import {buildTogglePinCreator} from './prioritiesListActions';

/** @type {PriorityListActions} **/
export const autoPrioritiesListActions = reduxList.actions;

autoPrioritiesListActions.togglePin = buildTogglePinCreator(autoPrioritiesListActions.deleteItem);



// WEBPACK FOOTER //
// ./src/js/priorities/actions/autoListActions.js